import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import "@mantine/notifications/styles.css";
import { theme, urqlPublicClient } from "@therapprove/common";
import "@therapprove/common/src/lib-styles.css";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "urql";
import App from "./App/App.js";
import "./index.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

const root = ReactDOM.createRoot(rootElement);
root.render(
    <StrictMode>
        <Provider value={urqlPublicClient}>
            <MantineProvider theme={theme}>
                <Notifications />
                <ModalsProvider>
                    <App />
                </ModalsProvider>
            </MantineProvider>
        </Provider>
    </StrictMode>
);
